import {
  formatDateLong as formatDate,
  formatDateTimeLong as formatDateTime,
} from '../../../../shared/src/utils/date-utils';

export { formatDate, formatDateTime };



// WEBPACK FOOTER //
// ./book/src/commons/utils/date-utils.js